// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutModal_container__3WFxd","closeButton":"AboutModal_closeButton__2WbXB"};